import { FileExcelOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import { ContentFilters, ContentTopBar } from 'components';
import { ClosingReportModal } from 'features/transaction_list/modal/closing-report-modal';
import { useState } from 'react';

import { ReportFilterForm } from './report-filter-form/report-list-filter';
import { ReportFilterFormValues } from './report-filter-form/types';

type ParticipateTopBarProps = {
  initialValues: ReportFilterFormValues;
  handleFilter: (values: ReportFilterFormValues) => void;
  refetch: () => void;
  isFetching: boolean;
};


export const ReportTopBar = ({
  initialValues,
  handleFilter,
  refetch,
  isFetching
}: ParticipateTopBarProps) => {

  const formId = 'reports-filters-form';

  const [participant, setParticipant] = useState<boolean>(false);

  const openParticipantModal = () => {
    setParticipant(true);
    document.body.style.overflow = 'hidden';
  }

  const closeParticipantModal = () => {
    setParticipant(false);
    document.body.style.overflow = 'visible';
  }



  return (

    <>
      <div className={`cstmrightmdl ${participant && "show"}`}>
        <ClosingReportModal
          closeModal={closeParticipantModal}
          isOpen={participant}
          refetch={refetch}
        />
      </div>

      <ContentTopBar
        title='Reports List'
        renderButtons={
          <Space>
            <Tooltip title={"Export"}>
              <Button
                icon={<FileExcelOutlined />}
                onClick={openParticipantModal}
                type='primary'
              // loading={loading}
              >
                Closing Report
              </Button>
            </Tooltip>
            <Button
              onClick={refetch}
              type='primary'
              loading={isFetching}
            >
              Refresh
            </Button>
          </Space>
        }
      />

      <ContentFilters formId={formId}>
        <ReportFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={initialValues}
        />
      </ContentFilters>


    </>
  );
};
